import { render, staticRenderFns } from "./commit-order.vue?vue&type=template&id=5a19a546&scoped=true"
import script from "./commit-order.vue?vue&type=script&lang=js"
export * from "./commit-order.vue?vue&type=script&lang=js"
import style0 from "./commit-order.vue?vue&type=style&index=0&id=5a19a546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19a546",
  null
  
)

export default component.exports